import React from "react";
import { Link } from "react-router-dom";

const ServiceList = [
    {
        link: "/local-moving",
        name: "Local Moving",
    },
    {
        link: "/long-distance-moving",
        name: "Long Distance Moving",
    },
    {
        link: "/commercial-moving",
        name: "Commercial Moving",
    },
    {
        link: "/full-packing",
        name: "Full Packing",
    },
];
const ServiceListFooter = () => {
    return (
        <div>
            {
                ServiceList.map((ls, index) =>
                    <Link to={ls.link}>{ls.name}</Link>
                )
            }
        </div>
    );
}

export default ServiceListFooter;